module.exports = __webpack_public_path__ + "static/media/collection-back.3fc0ec63.png";